export function createNodeAdapter(config) {
    const { editor } = config;
    const thisNodeIsEmpty = config.node.content.size === 0;
    let type = null;
    if (config.node.type.name === 'textBlock') {
        type = 'text';
    }
    if (config.node.type.name === 'headingBlock') {
        type = 'heading';
    }
    return {
        isEmpty: thisNodeIsEmpty,
        isFocused: config.selected,
        node: {
            id: config.node.attrs.tiptapNodeId ?? null,
            type,
        },
        blockId: config.node.attrs.blockId,
        delete() {
            config.deleteNode();
        },
        insert(props) {
            if (props.kind === 'text') {
                editor
                    .chain()
                    .focus()
                    .insertContent({
                    type: 'textBlock',
                    attrs: {
                        tiptapNodeId: `text_${Math.random().toString(36).substring(2, 9)}`,
                    },
                    content: [],
                })
                    .run();
            }
            if (props.kind === 'heading') {
                editor
                    .chain()
                    .focus()
                    .insertContent({
                    type: 'headingBlock',
                    attrs: {
                        level: props.level,
                        tiptapNodeId: `heading_${Math.random().toString(36).substring(2, 9)}`,
                    },
                    content: [],
                })
                    .run();
            }
            if (props.kind === 'callout') {
                editor
                    .chain()
                    .focus()
                    .insertContent({
                    type: 'calloutBlock',
                    attrs: {
                        tiptapNodeId: `callout_${Math.random().toString(36).substring(2, 9)}`,
                    },
                    content: [],
                })
                    .run();
            }
        },
    };
}
//# sourceMappingURL=nodeController.js.map